import PropTypes from "prop-types";
import { Row, Col } from "reactstrap";
import { useEffect, useState } from "react";
import { toast } from "../../../../core/helpers/message-helper";
import FormModal from "../../../../core/ui/components/FormModal";
import InputController from "../../../../core/ui/components/InputController";
import SelectController from "../../../../core/ui/components/SelectController";
import { useForm } from "react-hook-form";
import useUser from "../../../../core/hooks/use-user";
import {
    crearOeditarHoraExtra,
    selectEmpleadosConReglasOSecuenciasAreaSedeId,
} from "../../services/horas-extras-service";
const REQUIRED_RULE = {
    required: "Este campo es requerido",
};
const FormHorasExtras = ({ modalState, onSaved }) => {
    const { horasExtras } = modalState.data;
    const [empleados, setEmpleados] = useState([]);
    const { getUserData } = useUser();
    const user = getUserData();
    const [selectedArea, setSelectedArea] = useState(null);

    const defaultValues = {
        id: horasExtras.id == null ? "" : horasExtras.id,
        empleados: horasExtras.empleados == null ? [] : horasExtras.empleados,
        sede_area_lider:
            horasExtras.sede_area_lider == null
                ? []
                : horasExtras.sede_area_lider,
        fecha_inicio: horasExtras.fecha == null ? "" : horasExtras.fecha,
        fecha_fin: horasExtras.fecha_fin == null ? "" : horasExtras.fecha_fin,
        diurna: horasExtras.diurna == null ? 0 : horasExtras.diurna,
        nocturna: horasExtras.nocturna == null ? 0 : horasExtras.nocturna,
        diurna_festiva:
            horasExtras.diurna_festiva == null ? 0 : horasExtras.diurna_festiva,
        nocturna_festiva:
            horasExtras.nocturna_festiva == null
                ? 0
                : horasExtras.nocturna_festiva,
        observacion:
            horasExtras.observacion == null ? "" : horasExtras.observacion,
    };

    const onChangeSedeAreaLider = (area) => {
        setSelectedArea(area);

        // Vaciar el contenido del select de "Colaborador"
        form.setValue("empleados", []);
    };

    const areas = user.sedes_areas.reduce((prev, sedeArea) => {
        prev[sedeArea.area.id + sedeArea.sede.id] = {
            label: sedeArea.area.nombre + " - " + sedeArea.sede.nombre,
            value: sedeArea.sede_has_area_id,
            area_id: sedeArea.area.id,
            sede_id: sedeArea.sede.id,
        };

        return prev;
    }, {});

    useEffect(async () => {
        if (!selectedArea) return;
        const resp = await selectEmpleadosConReglasOSecuenciasAreaSedeId(
            selectedArea
        );

        if (!resp.status) return toast.error(resp.message);

        setEmpleados(
            resp.data.map((empleado) => {
                return {
                    label: empleado.info_persona,
                    value: empleado.id,
                };
            })
        );
    }, [selectedArea]);

    const form = useForm({ defaultValues });
    useEffect(() => form.reset(defaultValues), [horasExtras]);

    const onCreateHorasExtras = async (horaExtra) => {
        const resp = await crearOeditarHoraExtra({
            ...horaExtra,
            empleados: horaExtra.empleados.map((emp) => emp.value),
            sede_area_lider: horaExtra.sede_area_lider.value,
        });

        if (!resp.data.status) return toast.error(resp.data.message);
        onSaved(resp.data.message);
    };

    return (
        <FormModal
            size="lg"
            form={form}
            id="formHorasExtras"
            onSubmit={onCreateHorasExtras}
            isOpen={modalState.show}
            headerTitle={modalState.title}
            closeModal={() => modalState.set({ show: false })}
        >
            <Row>
                <InputController
                    type="hidden"
                    name="id"
                    errors={form.formState.errors}
                    control={form.control}
                />
                <Col sm={5}>
                    <SelectController
                        label="Area"
                        name="sede_area_lider"
                        onChange={onChangeSedeAreaLider}
                        options={Object.values(areas)}
                        rules={REQUIRED_RULE}
                        errors={form.formState.errors}
                        control={form.control}
                        isDisabled={!selectedArea}
                    />
                </Col>
                <Col sm={7}>
                    <SelectController
                        label="Colaborador"
                        isMulti={true}
                        options={empleados}
                        name="empleados"
                        rules={REQUIRED_RULE}
                        errors={form.formState.errors}
                        control={form.control}
                        isDisabled={modalState.title === "Editar Hora Extra"}
                    />
                </Col>
                <Col sm={4}>
                    <InputController
                        type="date"
                        errors={form.formState.errors}
                        control={form.control}
                        rules={REQUIRED_RULE}
                        name="fecha_inicio"
                        label="Fecha inicio"
                    />
                </Col>
                <Col sm={4}>
                    {modalState.title === "Editar Hora Extra" ? null : (
                        <InputController
                            type="date"
                            errors={form.formState.errors}
                            control={form.control}
                            name="fecha_fin"
                            label="Fecha fin"
                        />
                    )}
                </Col>
                <Col lg={4}>
                    <InputController
                        type="number"
                        label="Horas diurnas"
                        name="diurna"
                        control={form.control}
                        errors={form.formState.errors}
                        rules={REQUIRED_RULE}
                    />
                </Col>
                <Col lg={4}>
                    <InputController
                        type="number"
                        label="Horas nocturnas"
                        name="nocturna"
                        control={form.control}
                        errors={form.formState.errors}
                        rules={REQUIRED_RULE}
                    />
                </Col>
                <Col lg={4}>
                    <InputController
                        type="number"
                        label="Horas diurnas festivas"
                        name="diurna_festiva"
                        control={form.control}
                        errors={form.formState.errors}
                        rules={REQUIRED_RULE}
                    />
                </Col>
                <Col lg={4}>
                    <InputController
                        type="number"
                        label="Horas nocturnas festivas"
                        name="nocturna_festiva"
                        control={form.control}
                        errors={form.formState.errors}
                        rules={REQUIRED_RULE}
                    />
                </Col>
                <Col lg={12}>
                    <InputController
                        type="textarea"
                        label="Observaciones generales para el empleado"
                        name="observacion"
                        control={form.control}
                        errors={form.formState.errors}
                        rules={REQUIRED_RULE}
                    />
                </Col>
            </Row>
        </FormModal>
    );
};

FormHorasExtras.propTypes = {
    modalState: PropTypes.object,
    onSaved: PropTypes.func,
};

export default FormHorasExtras;
